// TrainingVideosList.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const TrainingVideosList = () => {
  // Data for video tables, can update if anything changes
  const trainingVideosData = [
    {
      id: 1,
      name: 'UKSPF - Creating a Project',
      url: '01+-+Creating+a+1+year+project.mp4',
      summary: 'This video covers the process of creating a 1-year project.'
    },
    {
      id: 2,
      name: 'UKSPF - Funding a Project',
      url: '02+-+Adding+funding.mp4',
      summary: 'Learn how to add funding to your project in this video.',
    },
     {
      id: 3,
      name: 'Adult Skills Fund - Managing Destinations',
      url: '01+-+Destinations+Walkthrough.mp4',
      summary: 'A guide to adding destinations to your data from the ILR',
    },
    // Add more video data as needed
  ];

  const handleClick = (url, name) => {
    localStorage.setItem('videoUrl', url);
    localStorage.setItem('videoName', name);
  };

  return (
    <div className="training-videos-list">
      <Link to="https://portal.wmca.org.uk/#/" className="back-to-dashboard-button">
        Back to Dashboard
      </Link>
      <h2>Training Videos List</h2>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Summary</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {trainingVideosData.map((video) => (
            <tr key={video.id}>
              <td>{video.name}</td>
              <td>{video.summary}</td>
              <td>
                <Link
                  to={`/training-videos/${video.url}`}
                  onClick={() => handleClick(video.url, video.name)}
                >
                  Watch Video
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TrainingVideosList;